import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import SolidShieldCheckIcon from 'LuxKit/Icons/solid/SolidShieldCheckIcon'
import SearchTileRowInclusionItem, { type SearchTileRowInclusion } from './SearchTileRowInclusionItem'

export type SearchTileCancellationInclusionKind = 'free' | 'flexible'

interface Props {
  kind: SearchTileCancellationInclusionKind
}

export function useSearchTileCancellationInclusion(
  kind: SearchTileCancellationInclusionKind,
): SearchTileRowInclusion
export function useSearchTileCancellationInclusion(
  kind: undefined,
): undefined
export function useSearchTileCancellationInclusion(
  kind: SearchTileCancellationInclusionKind | undefined,
): SearchTileRowInclusion | undefined
export function useSearchTileCancellationInclusion(
  kind: SearchTileCancellationInclusionKind | undefined,
): SearchTileRowInclusion | undefined {
  const intl = useIntl()
  const freeLabel = intl.formatMessage({
    id: 'Q-Vcg0q9UWQuGYlad6xb',
    defaultMessage: 'Free cancellation',
    description: 'Highlight text for free cancellation policy on search tiles',
  })
  const flexibleLabel = intl.formatMessage({
    id: 'hCwWYZZ-Qge1iETJVsZy',
    defaultMessage: 'Flexible cancellation',
    description: 'Highlight text for flexible cancellation policy on search tiles',
  })

  return useMemo(() => {
    if (kind === 'flexible') {
      return {
        id: 'compact-cancellation-flexible',
        description: flexibleLabel,
        Icon: SolidShieldCheckIcon,
        iconColour: 'highlight-primary-dark',
      }
    }
    if (kind === 'free') {
      return {
        id: 'compact-cancellation-free',
        description: freeLabel,
        Icon: SolidShieldCheckIcon,
        iconColour: 'highlight-primary-dark',
      }
    }
    return undefined
  }, [flexibleLabel, freeLabel, kind])
}

function SearchTileFreeCancellationInclusion({ kind }: Props) {
  const inclusion = useSearchTileCancellationInclusion(kind)

  return <SearchTileRowInclusionItem
    inclusion={inclusion}
    variant="small"
  />
}

export default SearchTileFreeCancellationInclusion
